export const FT = "FT";
export const FMX = "FMx";
export const MAIN_CONFIGURATION = "main configuration";
